import React from 'react'
import styled from 'styled-components'
import PartnerItem from './PartnerItem'
import { Data } from './data'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1280px;
  margin: auto;
  margin-top: 0;
`

const StyledTitle = styled.h2`
  color: #262626;
  font-size: 24px;
  padding: 1.5rem;

  strong {
    color: #ff550b;
  }

  @media screen and (max-width: 1024px) {
    padding: 0.75rem;
  }
`

const StyledPartnerContainer = styled.ul`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1.5rem;
`

const PartnersContainer = ({ isLogicImmo }) => {
  const content = (
    <Container>
      <StyledTitle isLogicImmo={isLogicImmo}>
        {isLogicImmo ? 'Logic-immo' : 'SeLoger'} a choisi <strong>Des Bras En Plus</strong> pour votre bien
      </StyledTitle>
      <StyledPartnerContainer>
        {Data.map(val => (
          <PartnerItem isLogicImmo={isLogicImmo} key={val.key} className="partner-item" title={val.title} text={val.text} img={val.img} />
        ))}
      </StyledPartnerContainer>
    </Container>
  )
  return content
}

export default PartnersContainer
